module.exports = __webpack_public_path__ + "img/kotlin.e997d567.svg";